import React, { Component } from 'react';
import {Form} from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { crewSkillListAction, crewSkillSaveAction,crewAffSkillListAction} from '../../../actions/crewActions';
import {validateCrewAddAction,validateCrewDetailsAction} from '../../../actions/validateActions'; 
import {clearAction} from '../../../actions/commonActions';
import {skillDocumentListAction} from '../../../actions/documentActions';
import ModalWindow from '../../commons/helpers/modalWindow';

import * as types from '../../../actions';
import { LBL_BTN_ADDNEW, LBL_SKILL, LBL_SKILLS, LBL_SELECT, LBL_IF_THERE_IS_A_CERTIFICATION, LBL_YEARS, LBL_MONTHS, LBL_REMOVE_THIS_ROW, LBL_SAVE, LBL_ARE_YOU_SURE_DELETE_SKILL, LBL_FROM_CREW_MEMBER,LBL_CONFIRM_DELETE } from '../../../configs/labelConfigs'; 
import { MSG_SKILL_SAVE_SUCCESS,MSG_SKILL_SAVE_ERROR,MSG_SKILL_DUP_ERROR, MSG_DATA_SAVE_ERROR } from '../../../configs/msgConfigs'; 


class Skills extends Component {

    constructor(props){
        super(props)
        this.state = {
            skills:[{skill_id:0,years:0,months:0,is_active:true,crew_skill_id:''}],
            deleteRowIndex: 0,        
            skillName:'',  
            addNewClicked: 0,       
        }
        this.addNewRow = this.addNewRow.bind(this); 
        this.removeRow = this.removeRow.bind(this); 
        this.onHandleChange = this.onHandleChange.bind(this); 
        this.callToaster    = this.callToaster.bind(this);

        this.modalDelete = React.createRef(); 
        
    }

    addNewRow = () =>{
        this.setState((prevState)=>({
            skills:[...prevState.skills,{skill_id:0,years:0,months:0,is_active:true,crew_skill_id:''}],addNewClicked:1
        }));

    }

    deleteBtnClick = (e,indexNum,skillId) =>{
    
        if(skillId!==0){
            const skill = this.props.skillList.filter((item,index) => item.id===skillId);
            this.setState({deleteRowIndex: indexNum,skillName: skill[0].skill_name}, () => this.modalDelete.current.handleOpenModal()); 

        }else{
            this.setState({ skills: this.state.skills.filter((s, sidx) => indexNum !== sidx) });
        }        


    }

    onDeleteAction = () =>{
        this.removeRow(this.state.deleteRowIndex);
        this.modalDelete.current.handleModelClose();     
    }

    onModalFormReset = () =>{ 
        this.setState({deleteRowIndex:0,skillName:''}); 
    }

    removeRow = () =>{
        this.setState({ skills: this.state.skills.filter((s, sidx) => this.state.deleteRowIndex !== sidx) });
    }

    onHandleChange = (e, fieldType) =>{    
        //if(["skill_id","years","months"].includes(e.target.className))
        if(fieldType==='skill_id' || fieldType==='years' || fieldType==='months'){ 
            let skills = [...this.state.skills];
            let value = Number(e.target.value);
            skills[e.target.dataset.id][fieldType] = value; // e.target.className
            this.setState({skills});
        }
    }

    checkDuplicate(array){
        const unique = [];
        let val = false;
        array.filter(o => {
            if(unique.find(i => i.skill_id === o.skill_id)) {
                return val =  true
            }else{
                unique.push(o)
                return val = false;
            }            
        })
        return val;
    }

    checkEmpty = (array) => {
        let retVal = true; 
        array.forEach(item => {
            if(Number(item.skill_id)===0) {
                retVal = false; 
            }           
        });
        return retVal; 
    }

    onSaveData = (e) =>{
        e.preventDefault();     
        console.log(this.state.skills)
        // if(this.checkDuplicate(this.state.skills)){
        //     this.callToaster(true,MSG_SKILL_DUP_ERROR,false);
        //     return false; 
        // }
        if(!this.checkEmpty(this.state.skills)){ 
            // this.callToaster(true,MSG_SKILL_SAVE_ERROR,false);
            return false; 
        }else{
            let data = {
                crew_profile_id: this.props.crewId, 
                skills_data: this.state.skills
            }
            this.props.crewSkillSaveAction(data);
        }         
    }

    callToaster(isEnabled,message,isSucces) {
        this.props.setToasterState(isEnabled,message,isSucces);
    }

    setStateUpdate(subactivity,crewSkill,status,errorData){
        if(subactivity===types.CREW_SKILL_LIST_SUCCESS){
            if(crewSkill.hasOwnProperty("skills_data")){
                //crewSkill.skills_data.forEach(function(item){ delete item.crew_skill_id  });
                this.setState({skills:crewSkill.skills_data})
            }
        }else if(subactivity===types.CREW_SKILL_SAVE_SUCCESS){
            this.callToaster(true,MSG_SKILL_SAVE_SUCCESS,true);
            this.props.skillDocumentListAction({crew:this.props.crewId,client:undefined});
            this.props.validateCrewDetailsAction(this.props.crewId);
            this.props.crewSkillListAction(this.props.crewId);
            this.props.reloadParentCrewList(); 
        }else if(subactivity===types.CREW_SKILL_SAVE_ERROR){            
            if(status===400){
                // this.callToaster(true,JSON.stringify(errorData),false);
                this.callToaster(true,MSG_DATA_SAVE_ERROR,false); 
                console.log(errorData); 
            }else{
                this.callToaster(true,MSG_SKILL_SAVE_ERROR,false);
            }
        }

    }

    componentDidUpdate(prevProps){
        const { subactivity, crewSkill,status,errorData} = this.props; 
        if (subactivity !== prevProps.subactivity) {
            this.setStateUpdate(subactivity,crewSkill,status,errorData);
            this.props.clearAction();
        }
        if(this.props.crewId > 0 && this.props.crewId!== prevProps.crewId){
            this.props.crewSkillListAction(this.props.crewId); 
        }
    }

    componentDidMount() {
        if(this.props.crewId){
            this.props.crewSkillListAction(this.props.crewId); 
        }
        this.props.crewAffSkillListAction({page:0,column:'skill_name',pageSize:''});
    }

    render(){
        let {skills,addNewClicked} = this.state;
        let {skillList,crewData} = this.props;
        let companyName = ''; 
        if(this.props.hasOwnProperty('showNameInHeader')) companyName = this.props.showNameInHeader;
        let arrSavedSkillIds = []; 
        skills.forEach(item => { 
            arrSavedSkillIds.push(Number(item.skill_id));
        } );
        let skillRows = skills.length; 
        
        let tmpSkillArray = Array.isArray(skillList) ? skillList : []; 

        let activeSkillList = tmpSkillArray.filter((item,index) => item.is_active===true);
        let allSkillRows = Array.isArray(activeSkillList) ? activeSkillList.length : 0; 

        // let allSkillRows = Array.isArray(skillList) ? skillList.length : 0; 

        return(
            <div className="col-md-12">
                <div className="box margin-top-12">
                    <div className="tab-head"> 
                        {/* <h6>{LBL_SKILLS}  {(companyName) && <span>{' - '+companyName}</span>}</h6> */}
                        <h6>&nbsp;</h6>
                        <div className="float-right padding-10">
                            {skillRows < allSkillRows && <button className="btn btn-primary " onClick={(e) => this.addNewRow(e)} >{LBL_BTN_ADDNEW}</button>}
                            {skillRows >= allSkillRows && <button className="btn disabledElement btnWidth100 " disabled >{LBL_BTN_ADDNEW}</button>}
                        </div>
                    </div> 
                    <Form onSubmit={e => this.onSaveData(e)}>                                           
                        <div className="box-content">
                            <label> {LBL_IF_THERE_IS_A_CERTIFICATION} </label>    
                                {skills.map((item,index)=>{
                                let skillId = `skill_id-${index}`, yearId = `years-${index}`, monthId = `months-${index}`;
                                return(
                                    <div className="row skill-row" key={index}>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>{LBL_SKILL}  </label>
                                                <div className="form-group select-input">
                                                    <select name={skillId} data-id={index} value={item.skill_id} className={Number(item.skill_id)===0 ? 'skill_id input-error' : 'skill_id'} onChange={e => this.onHandleChange(e,'skill_id')}  >
                                                        {/* <option value="0">{LBL_SELECT}</option>
                                                        {skillList.map((opt) => <option key={opt.id} value={opt.id}>{opt.skill_name}</option>)}   */}
                                                        {Number(item.skill_id)===0 && <option value="0">{LBL_SELECT}</option>}
                                                        {skillList.map((opt) => { 
                                                            if(Number(item.skill_id)===0 && !arrSavedSkillIds.includes(Number(opt.id)) && opt.is_active) {
                                                                return(<option key={opt.id} value={opt.id}>{opt.skill_name}</option>); 
                                                            }
                                                            else if(Number(opt.id)===Number(item.skill_id)) return(<option key={opt.id} value={opt.id}>{opt.skill_name}</option>); 

                                                            })}  
                                                    </select>
                                                </div>
                                            </div>
                                        </div> 
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>{LBL_YEARS}</label>
                                                <div className="text-input"><input className="years" type="number" min="0" max="99" name={yearId} data-id={index} onChange={e => this.onHandleChange(e,'years')} value={item.years}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>{LBL_MONTHS}</label>
                                                <div className="text-input"><input className="months" type="number" min="0" max="11" name={monthId} data-id={index} onChange={e => this.onHandleChange(e,'months')} value={item.months}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="clearfix remove-btn">
                                                    <span onClick={e => this.deleteBtnClick(e,index,item.skill_id)}><i className="las la-minus-circle text-red spanPointer" title={LBL_REMOVE_THIS_ROW}></i></span>
                                            </div>                                            
                                        </div>
                                    </div>
                                )
                            })} 
                            <div className="clearfix">
                                <button className="btn btn-primary float-right">{LBL_SAVE}</button>
                            </div>                        
                        </div>
                    </Form> 
                    <div className="padding-top-50">&nbsp;</div>
                    <div className="padding-top-50">&nbsp;</div>
                    <div className="padding-top-50">&nbsp;</div>
                    <div className="padding-top-50">&nbsp;</div>
                    <div className="padding-top-50">&nbsp;</div>
                    <div className="padding-top-50">&nbsp;</div>
                </div>
                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}> {LBL_ARE_YOU_SURE_DELETE_SKILL+' '+this.state.skillName+' '+LBL_FROM_CREW_MEMBER+' '+crewData.basicInfo.firstName+' '+crewData.basicInfo.lastName+"' ?"} </ModalWindow>  

            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        skillList:state.crews.skillList,
        crewSkill:state.crews.crewSkill,
        status:state.crews.status,
        subactivity:state.crews.subactivity,  
        errorData:state.crews.errorData,      
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        crewAffSkillListAction:crewAffSkillListAction,
        crewSkillListAction:crewSkillListAction,  
        crewSkillSaveAction:data=>crewSkillSaveAction(data),
        skillDocumentListAction:skillDocumentListAction,
        validateCrewDetailsAction:validateCrewDetailsAction,
        clearAction:clearAction   
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(Skills);